
import Component from './component';
import createComponentFactory from '../createComponent';

class ReadMore extends Component {

  constructor(element, context, options) {
    super(element, context, options);

    this.counter = 0;
    this.addnum = 0;
    this.childnum = 0;

    this.btn = element.querySelector('.js-readMore__btn');
    this.container = element.querySelector('.js-readMore__container');

    this._handleBtnClick = this._handleBtnClick.bind(this);
  }

  _addEvents() {
    this.btn.addEventListener('click', this._handleBtnClick);
  }

  _removeEvents() {
    this.btn.removeEventListener('click', this._handleBtnClick);
  }

  _handleBtnClick(evt) {
    evt.preventDefault();

    this.counter = this.counter + this.addnum;
    if(this.counter >= this.childnum) {
      this.btn.style.display = 'none';
    }

    Array.prototype.slice.call(this.container.children).forEach((element, index) => {
      if(index<this.counter) {
        element.style.display = 'block';
      } else {
        element.style.display = 'none';
      }
    });


  }

  _initBtn() {
    this.childnum = this.container.childElementCount ;

    if(this.element.id == 'js_readMore__event'){
      this.counter = 3;
      this.addnum = 3;
    }else if(this.element.id == 'js_readMore__guide'){
      this.counter = 1;
      this.addnum = 1;
    }else{
      this.counter = 8;
      this.addnum = 8;
    }
  }

  _destroyBtn() {
    Array.prototype.slice.call(this.container.children).forEach((element, index) => {
      element.style.display = '';
    });
  }

  didRegisterComponent() {
    this._initBtn();
    this._addEvents();
  }


  didUnregisterComponent() {
    this._destroyBtn();
    this._removeEvents();
  }
}

export default createComponentFactory(ReadMore);



// WEBPACK FOOTER //
// ./src/js/app/component/readMore.js